import React from 'react';
import { Link as Linkant } from 'react-router-dom';

import styled from '../../styled-components';

type PropType = {
    className?: string;
    text?: string;
    url?: any;
};

const Link = (props: PropType) => (
    <Linkant {...props} className={`form-input-label ${props.className || ''}`} to={props.url}>{props.text}</Linkant>
);

const LabelCmp = styled.label`
  color: #333;
  display: block;
  font-weight: 400;
  padding: 15px 0 5px 0;
  width: 100%;

  &.auth-style {
    color: #999;
    font-weight: 700;
    text-transform: uppercase;
  }
`;

export default Link;
